.action-bar-tab-controls {
    max-width: 700px;
}
